function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-arrow-lite_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.33 9.104l5.534-5.55a.465.465 0 00-.659-.658L6 8.116.794 2.896a.465.465 0 10-.658.657l5.535 5.55a.465.465 0 00.658 0z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-arrow-lite_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(90 6 6)",
  d: "M0 0h12v12H0z"
})));

function SvgIconArrowLite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconArrowLite;